module.exports = __webpack_public_path__ + "static/media/CompleteEvaluate.0c9d676d.svg";